import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import * as React from 'react';
import { Close12, Paragraph1, useDeviceType, Popover } from '@cian/ui-kit';
import classNames from 'classnames';
import { formatPhoneWithSpecialChars } from '../../utils/formatString';
import { ERememberedAccountType } from '../../types/rememberedAccounts';
import { mapTypeToIcon } from './mapTypeToIcon';
import * as styles from './styles.css';
export var RememberedAccountItem = function RememberedAccountItem(_ref) {
  var type = _ref.type,
    value = _ref.value,
    index = _ref.index,
    onClick = _ref.onClick,
    onDelete = _ref.onDelete;
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    popoverVisible = _React$useState2[0],
    setPopoverVisible = _React$useState2[1];
  var deviceType = useDeviceType();
  var showPopover = React.useCallback(function () {
    setPopoverVisible(true);
  }, []);
  var hidePopover = React.useCallback(function () {
    setPopoverVisible(false);
  }, []);
  var handleClick = React.useCallback(function () {
    onClick(type, value, index);
  }, [type, value, index, onClick]);
  var handleDelete = React.useCallback(function (e) {
    e.stopPropagation();
    onDelete(type, value, index);
  }, [type, value, index, onDelete]);
  var formattedValue = React.useMemo(function () {
    if (type === ERememberedAccountType.Phone) {
      return formatPhoneWithSpecialChars(value);
    } else {
      return value;
    }
  }, [value, type]);
  return /*#__PURE__*/React.createElement("div", {
    onClick: handleClick,
    className: classNames(styles['container'], styles["container--".concat(deviceType)])
  }, /*#__PURE__*/React.createElement("div", {
    className: styles['icon']
  }, mapTypeToIcon(type)), /*#__PURE__*/React.createElement("div", {
    className: styles['text-value']
  }, /*#__PURE__*/React.createElement(Paragraph1, null, formattedValue)), /*#__PURE__*/React.createElement(Popover, {
    placement: "bottom-start",
    content: /*#__PURE__*/React.createElement("div", {
      className: styles['popover']
    }, "\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0438\u0437 \u0441\u043F\u0438\u0441\u043A\u0430"),
    open: popoverVisible
  }, /*#__PURE__*/React.createElement("button", {
    "data-name": "CloseBtn",
    className: classNames(styles['delete-button'], styles["delete-button--".concat(deviceType)]),
    onMouseEnter: showPopover,
    onMouseLeave: hidePopover,
    onClick: handleDelete
  }, /*#__PURE__*/React.createElement(Close12, null))));
};